import { Printer } from "lucide-react";

import { Checkbox } from "@/components/ui/checkbox";

/**
 * Caixa no topo da conferência do envio (dono, 25/09/2026): marcada, nenhum
 * produto sai no cupom de preparo — o pedido vai completo pra cozinha, só não
 * imprime. Desmarcar volta todos a imprimir. Fica marcada sozinha quando cada
 * produto foi desligado um a um.
 */
export default function DesativarTodosPreparo({ chaves, desligados, onMudar }) {
  const todos = chaves.length > 0 && chaves.every((k) => desligados.has(k));
  return (
    <label className={`flex items-center gap-3 rounded-lg border px-3 py-2.5 cursor-pointer select-none transition-colors ${
      todos ? "border-red-500/50 bg-red-500/10" : "border-border hover:bg-muted/50"}`} data-e2e="conferencia-desativar-todos">
      <Checkbox checked={todos} onCheckedChange={(v) => onMudar(v ? new Set(chaves) : new Set())} className="h-5 w-5" />
      <Printer className={`w-4 h-4 shrink-0 ${todos ? "text-red-500" : "text-muted-foreground"}`} />
      <span className="text-sm font-semibold leading-tight">
        Desativar todos
        <span className="block text-[11px] font-normal text-muted-foreground">nenhum item sai no cupom de preparo</span>
      </span>
    </label>
  );
}
